import React from "react";
import PropTypes from "prop-types";
import { CardExpiryElement } from "react-stripe-elements";
import InputLabel from "components/v3/input-label/InputLabel";
import stripeStyles from "components/v3/payment-form/stripeStyles";
import styles from "./styles.module.scss";

class CardExpiry extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: {},
            empty: true
        };

        this._onChange = this._onChange.bind(this);
    }

    _onChange({ error, empty }) {
        this.props.onStripeError("cardExpiry", error);

        this.setState({
            error: error || {},
            empty
        });
    }

    render() {
        const { error, empty } = this.state;
        const className = `${ styles.expiry } ${ empty ? styles.empty : "" } ${ error.message ? styles.error : "" }`;

        return (
            <div className={ className }>
                <div className={ styles.inputLabel }>
                    <InputLabel
                        name="expiry"
                        label={ error.message || "Expiration Date" }
                    />
                </div>
                <CardExpiryElement
                    style={ stripeStyles }
                    className="stripeInput"
                    placeholder="MM / YY"
                    onChange={ this._onChange }
                />
            </div>
        );
    }
}

CardExpiry.propTypes = {
    onStripeError: PropTypes.func.isRequired
};

export default CardExpiry;
